import React from 'react';
import PropTypes from 'prop-types';
import { COMPLETED, ERROR, FAILURE, IN_PROGRESS, LOCKED,
  MAIN_TIMELINE_MSG1, MAIN_TIMELINE_MSG2, TIMELINE_STAGES , API_PATH } from "../../constants/dashboardTimelineConstants";
import { UserImage } from "../SvgComponents/UserImage";
import { QuestionMark } from "../SvgComponents/QuestionMark";
import { StatusTimelineLoader } from '../../components/BaseComponents/StatusTimelineLoader/index';

class DashBoardStatusTimeline extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      timelineDataFetched: false
    }
  }

  componentDidMount = async () => {
    const { authToken, mid, product, dashBoardServiceHost } = this.props;
    if( authToken && mid && product && dashBoardServiceHost) {
      const dashBoardServiceUrl = dashBoardServiceHost + API_PATH;
      const response = await fetch(dashBoardServiceUrl, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${authToken}`,
          'mid': `${mid}`,
          'product': `${product}`
        }
      });
      const dataFetched = response.status === 200;
      const jsonResponse = await response.json();
      if (dataFetched) {
        const { result: { onboarding , gmv } = {} } = jsonResponse;
        this.setState({timelineDataFetched: dataFetched, timelineData: onboarding, gmvAmount: gmv || 0 });
      }
    }
  };


  renderButton = () => {
   if(this.link){
     const linkText = this.link.text,
       linkTo = this.link.to(this.props.onBoardingHost, this.props.careHost);
     return (
       <div className="btn-sec">
         <p>Instant Activation. Hassle-Free!</p>
         <a className="btn" href={linkTo} target="_blank">{linkText}</a>
       </div>
     );
   }
  };

  renderTimelineStages = () => {
    const stageList = Object.entries(TIMELINE_STAGES);
    let link;
    return stageList.map(([stageName, stageData], index) => {
      const { status } = this.state.timelineData.timeline_status[stageName];
      const stageLabel = stageData.label;
      let stageMsg, stageClass;
      switch (status) {
        case COMPLETED:
          stageMsg = stageData.success.stageMsg;
          stageClass = 'step-completed';
          break;
        case IN_PROGRESS:
          stageMsg = stageData.inProgress.stageMsg;
          stageClass = 'step-inprogress';
          link = link || stageData.inProgress.link;
          break;
        case ERROR:
          stageMsg = stageData.error.stageMsg;
          stageClass = 'step-locked';
          link = link || stageData.error.link;
          break;
        case LOCKED:
          stageMsg = stageData.locked.stageMsg;
          stageClass = 'step-locked';
          link = link || stageData.locked.link;
          break;
        case FAILURE:
          stageMsg = stageData.failure.stageMsg;
          stageClass = 'step-locked';
          link = link || stageData.failure.link;
          break;
      }
      this.link = link;
      return (
        <li key={stageName} className={stageClass}>
          <span className="steps-bullets">
            <span className="step-num">{index+1}</span>
            <i className="right-tick">&nbsp;</i>
          </span>
          <span className="desc">
            <strong>{stageLabel}</strong><br />
            <small>{stageMsg}</small>
          </span>
        </li>
      );
    });
  };


  renderTimelineStagesData = () => {
    return <ul className="steps-completion">{this.renderTimelineStages()}</ul>;
  };

  renderProgressBar = () => {
    const gmvAmount = Math.floor(this.state.gmvAmount || 0),
      widthPercentage = Math.floor((gmvAmount*100)/50000);
    return (
      <div className="progress-bar-contnr">
        <span className="bar-text">
          <span className="left">Your Payment Limitation</span>
          <span className="qstn-mrk left">
            <QuestionMark />
          </span>
        </span>
        <div className="progress-bar">
          <span className="left-txt">0</span>
          <span className="right-txt">&#8377; 50,000</span>
          &#8377; 25,000
          <div className="bar">
            <span className="progress" style={{ width: `${widthPercentage}%` }}></span>
          </div>
        </div>
      </div>
    );
  };

  renderTimeline = () => {
    return (
      <div>
        <div className="content-container">
          <p className="title-heading">{MAIN_TIMELINE_MSG1}<strong>{MAIN_TIMELINE_MSG2}</strong></p>
          <span className="user-img">
            <UserImage />
          </span>
          {this.renderTimelineStagesData()}
          {this.renderButton()}
        </div>
        {this.renderProgressBar()}
      </div>
    );
  };

  render() {
    const dataFetched = this.state.timelineDataFetched;
    return(
      <div className="status-timeline-container">
        <div className={ dataFetched ? 'dashboard-status-timeline' : 'timeline-loader'}>
          {dataFetched ? this.renderTimeline() : <StatusTimelineLoader/>}
        </div>
      </div>
    );
  };
}

DashBoardStatusTimeline.propTypes = {
  authToken: PropTypes.string.isRequired,
  careHost: PropTypes.string.isRequired,
  dashBoardServiceHost: PropTypes.string.isRequired,
  mid: PropTypes.string.isRequired,
  onBoardingHost: PropTypes.string.isRequired,
  product: PropTypes.string.isRequired
};

DashBoardStatusTimeline.defaultProps = {
  authToken: '',
  careHost: '',
  dashBoardServiceHost: '',
  mid: '',
  onBoardingHost: '',
  product: ''
};
export default DashBoardStatusTimeline;
